import { NOT_UPDATED_ACTION_STATS_NAME } from '@/components/StatsCompareTable/constants';
import { FixtureAction } from '../types';

export interface BasketNotUpdatedActions {
  unknownPlayers: FixtureAction[];
}

export interface NotUpdatedActionsItem {
  name: string;
  actionValue: number;
  icon?: JSX.Element;
}

export const getBasketActionStats = (
  notUpdatedActions: BasketNotUpdatedActions,
): NotUpdatedActionsItem[] => {
  return [
    {
      name: NOT_UPDATED_ACTION_STATS_NAME.UNKNOWN_PLAYER,
      actionValue: notUpdatedActions.unknownPlayers.length ?? 0,
    },
  ];
};
